import { writeErrorLog } from '@lib/logger/logError';
import { extractErrorMessage } from '@lib/logger/extractErrorMessage';
import { type ApiResponse } from '@types';

export const handleApiError = <T = never>(
  message: string,
  error: unknown,
  source: string,
): ApiResponse<T> => {
  const raw = extractErrorMessage(error);

  void writeErrorLog(message, source, { rawError: error, error: raw });

  return {
    success: false,
    error: { message, raw },
  };
};
